import { render, staticRenderFns } from "./groupModel.vue?vue&type=template&id=5a8b7648"
import script from "./groupModel.vue?vue&type=script&lang=js"
export * from "./groupModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a8b7648')) {
      api.createRecord('5a8b7648', component.options)
    } else {
      api.reload('5a8b7648', component.options)
    }
    module.hot.accept("./groupModel.vue?vue&type=template&id=5a8b7648", function () {
      api.rerender('5a8b7648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/controlManage/groupFrom/groupModel.vue"
export default component.exports